export default __webpack_public_path__ + "static/media/skyrider_sword.80e60c22.png";